import React from 'react';

import {
  Avatar,
  PRONOUN_TAGS,
  ALL_CONTACT_TAGS,
  ContactTagType,
} from 'components';

import { IClientContact, ISupplierContact } from '@bb/contacts';
import {
  CompanyText,
  Container,
  EmployerContainer,
  FullProfileName,
  InfoContainer,
  NameContainer,
  PronounText,
  RoleTag,
  RolesContainer,
} from './common';

interface ContactProfileProps {
  contact: IClientContact | ISupplierContact;
}

const ContactProfile: React.FC<ContactProfileProps> = ({ contact }) => (
    <Container>
      <InfoContainer>
        <Avatar user={contact} width={36} />
        <NameContainer data-cy="contact-details-name-container">
          <FullProfileName level={2}>
            {`${contact.firstName} ${
              contact.lastName ? contact.lastName : ''
            }`.trim()}
          </FullProfileName>
          <PronounText>
            {contact.pronoun
              .map(key => PRONOUN_TAGS[key]?.label)
              .filter(Boolean)
              .join(', ')}
          </PronounText>
        </NameContainer>
        <RolesContainer data-cy="contact-details-role-container">
          {/* https://github.com/microsoft/TypeScript/issues/33591#issuecomment-642115970 */}
          {contact.tags.map((role: ContactTagType) => (
            <RoleTag key={role} color="blue">
              {ALL_CONTACT_TAGS[role]?.label.toLocaleLowerCase()}
            </RoleTag>
          ))}
        </RolesContainer>
        {contact.type === 'supplier' && (
          <EmployerContainer data-cy="contact-details-supplier-employer-container">
            <CompanyText>{contact.companyName}</CompanyText>
          </EmployerContainer>
        )}
      </InfoContainer>
    </Container>
  );

export default ContactProfile;
